import $ from 'jquery'

export function load (url, params, callback) {
  return $.ajax(url, {
    method: 'GET',
    data: params,
    success: function (data) {
      callback(data)
    }
  })
}
